/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var RvtIcon = createIcon("RvtIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#CAD0E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m31.6 18.958-.61 4.636-4.31.894 11.14 11.793-2.276 3.456-15.859-8.458-1.85 9.061-5.673-1.519 1.708-11.243.814-4.269 1.26-10.573 8.62-4.607 7.036 10.83Z",
    fill: "url(#rvt-a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.565 8.129 7.035 10.83-5.978-2.267-1.057-8.563Z",
    fill: "url(#rvt-b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m30.99 23.594.61-4.636-5.978-2.266 1.057 7.796 4.31-.894Z",
    fill: "url(#rvt-c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.82 36.28 26.68 24.489l-6.297 2.136-.698 4.655 15.859 8.458 2.277-3.456Z",
    fill: "url(#rvt-d)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.383 26.624 1.671-7.137 4.625 5.001-6.296 2.136Z",
    fill: "url(#rvt-e)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.565 8.129 21.93 19.543l4.748 4.945-2.114-16.36Z",
    fill: "url(#rvt-f)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.944 12.736 6.1 6.751.846-3.815-6.946-2.936Z",
    fill: "#25285F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.684 23.31 1.26-10.573 6.1 6.75-1.66 7.137-5.7-3.315Z",
    fill: "url(#rvt-g)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.565 8.129-8.62 4.607 6.945 2.936 1.675-7.543Z",
    fill: "#1E1C4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.383 26.624-2.772 3.82 2.074.835.698-4.655Z",
    fill: "#272F69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.685 31.279-1.85 9.061-5.673-1.519 5.45-8.376 2.073.834Z",
    fill: "url(#rvt-h)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.611 30.445-3.74-2.867-1.709 11.243 5.45-8.376Z",
    fill: "url(#rvt-i)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.87 27.578 6.513-.954-2.772 3.82-3.74-2.866Z",
    fill: "url(#rvt-j)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.87 27.578.814-4.269 5.7 3.315-6.514.954Z",
    fill: "#121325"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.675 16.721-2.785-1.05 1.675-7.542 1.11 8.592Z",
    fill: "url(#rvt-k)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-a",
    x1: "27.482",
    y1: "39.675",
    x2: "17.238",
    y2: "25.32",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".995",
    stopColor: "#263A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-b",
    x1: "28.536",
    y1: "18.734",
    x2: "25.801",
    y2: "14.035",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293D7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".995",
    stopColor: "#263A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-c",
    x1: "29.628",
    y1: "23.701",
    x2: "26.463",
    y2: "18.562",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#224083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-d",
    x1: "26.289",
    y1: "34.55",
    x2: "30.016",
    y2: "29.253",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".005",
    stopColor: "#27397C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#253C7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-e",
    x1: "23.629",
    y1: "26.131",
    x2: "22.663",
    y2: "21.704",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#24285D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-f",
    x1: "24.543",
    y1: "16.701",
    x2: "24.175",
    y2: "16.607",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#27326F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-g",
    x1: "17.953",
    y1: "24.841",
    x2: "19.67",
    y2: "17.819",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14133E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#212053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-h",
    x1: "15.246",
    y1: "40.099",
    x2: "18.393",
    y2: "33.524",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#27397C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-i",
    x1: "14.274",
    y1: "37.891",
    x2: "16.905",
    y2: "31.147",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#262860"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-j",
    x1: "17.289",
    y1: "29.134",
    x2: "17.233",
    y2: "28.036",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".005",
    stopColor: "#212053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#232459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rvt-k",
    x1: "24.283",
    y1: "16.24",
    x2: "24.526",
    y2: "11.677",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#28326F"
  }))));
}, {
  "i18nKey": "svg.RvtIcon"
});